<template>
<div data-aos="fade-left">
    <Header></Header>

    <div class="terms-wrapper">
        <div class="header-banner">
            <p>Allgemeine Geschäfts- und Nutzungsbedingungen (AGB & Nutzungsbedingungen)</p>
        </div>

        <div class="body">
            <div class="text-wrapper">
                <p class="subtitle dark">Allgemeine Geschäfts- und Nutzungsbedingungen (AGB & Nutzungsbedingungen)
                </p>
                <p class="dark">für den Service <b>CleanData</b>, betrieben durch die <b>LEVELS AG</b></p>
            </div>
 

            <div class="text-wrapper">
                <p class="subtitle dark"><b>1. Geltungsbereich</b></p>
                <p>
                    Diese Allgemeinen Geschäfts- und Nutzungsbedingungen (nachfolgend „Bedingungen“)<br>
                    regeln das Vertrags- und Nutzungsverhältnis zwischen der<br>
                    LEVELS AG, St. Galler Str. 5, 9042 Speicher, Schweiz<br>
                    (nachfolgend „LEVELS AG“ oder „Anbieter“)<br>
                    und den Nutzern der Online-Plattform CleanData unterwww.cleandata.ch (nachfolgend „CleanData“
                    oder „Dienst“).
                </p>
            </div>

            <div class="text-wrapper">
                <p>
                    Die Bedingungen gelten für alle Nutzer, unabhängig davon, ob der Dienst kostenlos oder
                    kostenpflichtig verwendet wird. Mit der Registrierung oder Nutzung der Plattform erklärt sich
                    der Nutzer mit diesen Bedingungen in der jeweils aktuellen Fassung einverstanden.
                </p>
            </div>

            <div class="text-wrapper">
                <p class="subtitle dark"><b>2. Leistungsbeschreibung</b></p>

                <p>
                    CleanData ist ein digitaler Service der LEVELS AG, der es Nutzern ermöglicht, ihre
                    Datenschutzrechte gemäss dem Bundesgesetz über den Datenschutz (DSG) und der
                    Datenschutz-Grundverordnung (DSGVO) automatisiert gegenüber Dritten wahrzunehmen.
                </p><br>

                <p>
                    Der Anbieter handelt im Auftrag des Nutzers und übermittelt datenschutzrechtliche Begehren (z.
                    B. Auskunfts- oder Löschungsanträge) an Dritte. Es besteht keine Garantie für Reaktion,
                    Vollständigkeit oder Löschung durch die angeschriebenen Unternehmen.
                </p><br>

                <p>CleanData bietet:</p><br>

                <ul>
                    <li>
                        <p class='terms-sm-text'>
                            eine kostenlose Version mit eingeschränkten Funktionen,
                        </p>
                    </li>
                    <li>
                        <p class='terms-sm-text'>
                            sowie kostenpflichtige Abonnemente mit erweitertem Leistungsumfang (z. B. wiederkehrende
                            Anfragen, Verwaltung von Befunden, Anstossen von Löschungen, Dokumentation).
                        </p>
                    </li>
                </ul><br>

                <p>
                    Der Anbieter kann kostenlose Leistungen jederzeit anpassen oder einstellen. 
                </p><br>

                 <p> 
                    Der Anbieter ist berechtigt, technische Anpassungen vorzunehmen, um Sicherheit, Stabilität oder
                    Funktionalität der Plattform zu gewährleisten.
                </p>
            </div>

            <div class="text-wrapper">
                <p class="subtitle dark"><b>3. Registrierung und Nutzung</b></p>

                <p>Für die Nutzung ist eine Registrierung mit vollständigen und wahrheitsgemässen Angaben
                    erforderlich</p><br>

                <p>Der Nutzer verpflichtet sich, im Rahmen der Registrierung die folgenden Daten anzugeben: </p><br>

                <ul>
                    <li>
                        <p class='terms-sm-text'>Vor- und Nachname</p>
                    </li>
                    <li>
                        <p class='terms-sm-text'>Geburtsdatum</p>
                    </li>
                    <li>
                        <p class='terms-sm-text'>Wohnadresse (Strasse, PLZ, Ort, Land)</p>
                    </li>
                    <li>
                        <p class='terms-sm-text'>Telefonnummer</p>
                    </li>
                    <li>
                        <p class='terms-sm-text'>gültige E-Mail-Adresse</p>
                    </li>
                    <li>
                        <p class='terms-sm-text'>Passwort</p>
                    </li>
                </ul><br>

                <p>
                    Diese Angaben sind notwendig, um eine eindeutige Zuordnung und die rechtsgültige Vertretung
                    gegenüber Dritten zu ermöglichen<br>
                    Der Upload eines amtlichen Ausweises ist <b>nicht Teil der Registrierung</b>, sondern erfolgt
                    <b>erst nach dem Login</b>, sobald der Nutzer eine Datenschutzvollmacht erteilt.
                </p><br>

                <p>Die Registrierung ist nur für volljährige und handlungsfähige Personen zulässig</p><br>

                <p>Der Nutzer verpflichtet sich weiter,</p><br>

                <ul>
                    <li>
                        <p class='terms-sm-text'>seine Zugangsdaten sicher aufzubewahren und nicht an Dritte
                            weiterzugeben,</p>
                    </li>
                    <li>
                        <p class='terms-sm-text'>keine unzutreffenden oder fremden Angaben zu machen,</p>
                    </li>
                    <li>
                        <p class='terms-sm-text'>den Dienst ausschliesslich für eigene, rechtmässige Zwecke zu
                            verwenden.</p>
                    </li>
                </ul><br>

                <p>
                    Der Anbieter kann Konten sperren oder löschen, wenn Verstösse gegen diese Bedingungen,
                    unvollständige oder falsche Angaben oder missbräuchliche Nutzungen festgestellt werden.
                </p>
            </div>

            <div class="text-wrapper">
                <p class="subtitle dark"><b>4. Identifikation, Datenbereitstellung und Upload eines amtlichen
                    Ausweises</b></p>

                <p>
                    Zur Durchführung von Auskunfts- und Löschungsbegehren ist eine eindeutige Identifikation des
                    Nutzers erforderlich.
                </p><br>

                <p>
                    Der Nutzer verpflichtet sich, nach erfolgter Registrierung und Login die für die Bearbeitung
                    notwendigen Daten vollständig und wahrheitsgemäss bereitzustellen. Hierzu gehören insbesondere:
                </p><br>

                <ul>
                    <li>
                        <p class='terms-sm-text'>eine gut lesbare Kopie eines gültigen amtlichen Ausweises (z. B.
                            Pass oder Identitätskarte),</p>
                    </li>
                    <li>
                        <p class='terms-sm-text'>eine digitale Unterschrift zur Legitimation,</p>
                    </li>
                    <li>
                        <p class='terms-sm-text'>persönliche Angaben (Name, Adresse, E-Mail-Adresse).</p>
                    </li>
                </ul><br>

                <p>
                    Der amtliche Ausweis wird ausschliesslich zur Identifikation gegenüber datenverarbeitenden
                    Unternehmen verwendet, damit CleanData im Namen des Nutzers rechtsgültig auftreten kann. Der
                    Upload erfolgt im Rahmen der digitalen Vollmacht nach Login. Ohne erfolgreiche Identitätsprüfung
                    kann CleanData keine Datenschutzbegehren im Namen des Nutzers durchführen.
                </p><br>

                <p>
                    Der Nutzer darf ausschliesslich <b>eigene Dokumente</b> hochladen.<br>
                    Das Hochladen oder Verwenden von Ausweisen, Unterschriften oder Daten Dritter ohne deren
                    ausdrückliche Zustimmung ist untersagt und kann rechtliche Konsequenzen nach sich ziehen.
                </p><br>

                <p>
                    Während der Laufzeit eines aktiven Abonnements können die hinterlegten Identifikationsdaten
                    (inkl. Ausweiskopie und Unterschrift) nicht gelöscht werden, da sie für wiederkehrende Anfragen
                    zwingend erforderlich sind. Nach Vertragsende werden diese Daten gemäss Datenschutzerklärung
                    gelöscht oder anonymisiert.
                </p>
            </div>

            <div class="text-wrapper">
                <p class="subtitle dark"><b>5. Vertragsabschluss und Zustimmung</b></p>

                <p>Der Vertrag kommt zustande, sobald der Nutzer den Registrierungsprozess abschliesst und den
                    Bedingungen zustimmt.</p><br>

                <p>Die Zustimmung erfolgt durch Aktivierung der Checkbox <b>„Ich stimme den CleanData-Bedingungen
                        zu“</b>. Optional kann der Nutzer den Erhalt des CleanData-Newsletters erlauben („Ich möchte
                    den CleanData-Newsletter erhalten“). Diese Einwilligung ist freiwillig und jederzeit
                    widerrufbar.</p><br>

                <p>
                    Der Nutzer bestätigt, dass er die AGB und die Datenschutzerklärung vor Abschluss des Vertrags
                    zur Kenntnis genommen hat und sie in zumutbarer Weise speichern oder ausdrucken konnte.
                </p>
            </div>
            <div class="text-wrapper">
                <p class="subtitle dark"><b>6. Zahlungsbedingungen</b></p>

                <p>
                    Für kostenpflichtige Abonnemente gelten die auf <b>www.cleandata.ch</b> publizierten Preise.
                    Alle Preise verstehen sich in Schweizer Franken (CHF) inklusive gesetzlicher Mehrwertsteuer,
                    sofern nicht anders angegeben.
                </p><br>

                <p>
                    Die Zahlung erfolgt im Voraus über den Zahlungsdienstleister <b>Payrexx</b>.<br>
                    Bereits begonnene oder bezahlte Leistungszeiträume werden nicht rückerstattet, ausser es besteht
                    eine gesetzliche Verpflichtung dazu.<br>
                    Ein Widerrufsrecht für digitale Dienstleistungen besteht nicht.
                </p><br>

                <p><b>MwSt.-Änderungen</b></p><br>

                <p>Alle angegebenen Preise verstehen sich inklusive der jeweils geltenden Schweizer Mehrwertsteuer.
                </p><br>

                <p>Ändert sich der gesetzliche Mehrwertsteuersatz während der Laufzeit eines Abonnements, so wird
                    dieser automatisch angepasst.</p><br>

                <p>Eine solche Anpassung berechtigt den Nutzer nicht zur ausserordentlichen Kündigung.</p><br>

                <p>Preisänderungen aufgrund von MwSt.-Anpassungen werden dem Nutzer rechtzeitig mitgeteilt.</p>
            </div>

            <div class="text-wrapper">
                <p class="subtitle dark"><b>7. Vertragslaufzeit und Kündigung</b></p>

                <ul>
                    <li>
                        <p class='terms-sm-text'><b>Monatsabo</b>: kann jederzeit gekündigt werden und bleibt bis
                            zum Ende der bereits bezahlten Periode aktiv.</p>
                    </li>
                    <li>
                        <p class='terms-sm-text'><b>Jahresabo</b>: verlängert sich automatisch um ein weiteres Jahr,
                            sofern es nicht spätestens <b>14 Tage vor Ablauf</b> der aktuellen Laufzeit gekündigt
                            wird.</p>
                    </li>
                </ul><br>

                <p>
                    Die Kündigung kann jederzeit über das Benutzerkonto erfolgen und wird mit Ablauf der laufenden
                    Aboperiode wirksam.<br>
                    Bereits bezahlte Beträge werden nicht rückerstattet.
                </p><br>

                <p>
                    Nach Kündigung bleibt das Benutzerkonto bestehen, sofern der Nutzer es nicht selbst löscht. Eine
                    Reaktivierung eines Abonnements ist jederzeit möglich. Nach Beendigung des Vertragsverhältnisses
                    werden personenbezogene Daten des Nutzers gelöscht oder anonymisiert, sofern keine gesetzlichen
                    Aufbewahrungspflichten bestehen.
                </p><br>

                <p>Details zur Speicherdauer und Löschung sind in der Datenschutzerklärung geregelt.</p>
            </div>

            <div class="text-wrapper">
                <p class="subtitle dark"><b>8. Haftung</b></p>

                <p>
                    Der Anbieter haftet ausschliesslich für Schäden, die auf vorsätzliches oder grob fahrlässiges
                    Verhalten zurückzuführen sind.<br>
                    Jegliche Haftung für indirekte Schäden, Folgeschäden oder entgangenen Gewinn ist ausgeschlossen,
                    soweit gesetzlich zulässig.
                </p><br>

                <p>
                    CleanData übernimmt keine Verantwortung für das Verhalten, die Reaktionszeiten, den Inhalt oder
                    die Entscheidungen der Dritten, an welche Anfragen übermittelt werden.<br>
                    Der Anbieter haftet nicht für die Nichterfüllung, verspätete Bearbeitung oder Ablehnung von
                    Auskunfts- oder Löschungsbegehren durch diese Dritten.
                </p>
            </div>

            <div class="text-wrapper">
                <p class="subtitle dark"><b>9. Datenschutz</b></p>

                <p> Die Verarbeitung personenbezogener Daten erfolgt gemäss der auf
                    <b>www.cleandata.ch/datenschutz</b> veröffentlichten Datenschutzerklärung, die Bestandteil
                    dieser Bedingungen ist.</p><br>

                <p>
                    Alle Mitarbeitenden und technischen Dienstleister von CleanData sind vertraglich zur
                    Vertraulichkeit und zum Schutz personenbezogener Daten verpflichtet
                </p>
            </div>

            <div class="text-wrapper">
                <p class="subtitle dark"><b>10. Änderungen des Dienstes und der Bedingungen</b></p>

                <p>Der Anbieter kann den Leistungsumfang von CleanData jederzeit anpassen, erweitern oder teilweise
                    einstellen.</p><br>

                <p>Änderungen dieser Bedingungen werden den Nutzern vorgängig mitgeteilt.</p><br>

                <p>Die fortgesetzte Nutzung des Dienstes gilt als Zustimmung zur geänderten Fassung.</p>
            </div>

            <div class="text-wrapper">
                <p class="subtitle dark"><b>11. Anwendbares Recht und Gerichtsstand</b></p>

                <p>
                    Es gilt ausschliesslich <b>Schweizer Recht</b> unter Ausschluss des internationalen Privatrechts.
                    Gerichtsstand ist der Sitz der LEVELS AG, <b>Speicher</b>, Schweiz.
                </p>
            </div>
            <div>
            </div>
        </div>

        <Footer></Footer>
    </div>
</div>
</template>

<script>
import Header from '../components/Header.vue';
import Footer from '../components/Footer.vue'

export default {
    components: {
        Header,
        Footer
    },
    data() {
        return {

            mobMenu: true,
            mobile: false,

            slideMobMenu: false,

            mobileImg: false,
        }
    },
    methods: {

        checkIfMobile() {
            if (window.innerWidth <= 768) {
                this.mobile = true;
            } else {
                this.mobile = false;
            }
        },

        checkIfMobileImg() {
            if (window.innerWidth <= 600) {
                this.mobileImg = true;
            } else {
                this.mobileImg = false;
            }
        },
        toggleMobileMenu() {
            this.slideMobMenu = !this.slideMobMenu;
            this.mobMenu = !this.mobMenu;
        }

    },
    mounted() {
        this.checkIfMobile();

        this.checkIfMobileImg();

        window.addEventListener("resize", this.checkIfMobile);
        window.addEventListener("resize", this.checkIfMobileImg);

    },
    beforeUnmount() {
        window.removeEventListener("resize", this.checkIfMobile);
        window.removeEventListener("resize", this.checkIfMobileImg);
    },
}
</script>

<style lang="scss" scoped>
ul {
    font-size: 18px;
    color: #666666;
    margin-left: 35px;

    p {
        margin: 0 !important;
    }
}

.header-banner {
    padding: 173px 0;
    text-align: center;
    background-color: #EDF2F7;
    margin-bottom: 55px;
    margin-top: 32px;

    p {
        font-size: 34px;
    }
}

.body {
    padding: 0 262px;
    margin-bottom: 180px;

    p,
    a {
        color: #3C3C3C;
        font-size: 18px;
    }
}

.subtitle {
    font-size: 20px !important;
    margin-bottom: 16px;
    font-weight: bold;
}

.text-wrapper {
    margin-bottom: 30px;
}

.dark {
    font-weight: 500;
}

///
nav {
    width: 78%;
    margin: 0 auto;
    margin-top: 26px;

    display: flex;
    align-items: center;
    justify-content: space-between;

}

.nav-logo {
    display: block;
    width: 100px;

    img {
        width: 100%;
    }
}

.nav-links {
    display: flex;
    align-items: center;
    gap: 42px;

    a {
        // font-size: 19px;
        font-size: 16px;
        color: #3C3C3C;
        cursor: pointer;
    }
}

.nav-btns {
    display: flex;
    align-items: center;
    gap: 31px;

}

.default-btn {
    display: block;
    width: 186px;
    cursor: pointer;
    border-radius: 20px;
    padding: 10px 0;
    text-align: center;
    font-size: 16px;
    transition: 0.3s ease;
    color: white;
    background-color: #FA3A67;
    border: 1px solid #FA3A67;

    &:hover {
        background-color: white;
        color: #FA3A67;
        border: 1px solid #FA3A67;
    }
}

.default-login-btn {
    color: #FA3A67;
    border: 1px solid #FA3A67;
    background-color: white;

    &:hover {
        background-color: #FA3A67;
        color: white;
    }
}

footer {
    background-color: #3C3C3C;
    padding: 22px 0;

    .footer-wrapper {
        width: 78%;
        margin: 0 auto;

    }

    .footer-top {
        width: 100%;
        justify-content: space-between;
        display: flex;
        margin-bottom: 100px;
    }

    .footer-bottom {
        justify-content: space-between;
        display: flex;
        align-items: center;
        border: 2px solid transparent;
        border-top-color: #464646;
        padding: 40px 0;
        padding-bottom: 18px;
        color: white;

        p {
            font-size: 18px;
        }

        .terms {
            justify-content: space-between;
            display: flex;
            align-items: center;
            gap: 96px;

            a {
                color: white;
                font-size: 18px;
            }
        }
    }
}

.footer-img-wrapper {
    p {
        font-size: 14px;
        color: white;
        margin-top: 42px;
    }
}

.footer-img {
    width: 120px;

    img {
        width: 100%;
    }
}

.footer-links {
    color: white;
    margin-top: 84px;

    .title {
        font-size: 20px;
        margin-bottom: 35px;
    }

    a {
        color: white;
        display: block;
        margin-bottom: 15px;
    }
}

.footer-socials {
    display: flex;
    align-items: center;
    gap: 35px;

    .social {
        img {
            width: 100%
        }

        width: 20px;
        height: 20px;

    }

    .youtube {
        width: 28px;
        height: 20px;
    }

    .facebook {
        width: 10px;
        height: 20px;
    }
}

/* 1920-1080 */
@media (min-width: 1920px) {
    .nav-logo {
        width: 140px;
    }

    .nav-links a {
        font-size: 22px;
    }

    .default-btn {
        padding: 12px 0;
        font-size: 19px;
    }

    .footer-img-wrapper p {
        font-size: 16px;
    }

    .footer-img {
        width: 140px;
    }

    .footer-links {
        .title {
            font-size: 24px;
        }

        a {
            font-size: 18px;
        }
    }

    .footer-bottom {
        p {
            font-size: 20px;
        }

        .terms {

            a {
                font-size: 20px;
            }
        }
    }

}

/* imac 24" */
/* 2048 x 1152 */
@media (min-width: 2048px) {}

/* 2304-1440 */
@media (min-width: 2304px) {

    //terms
    .header-banner p {
        font-size: 36px;
    }

    .body {

        p,
        a {
            font-size: 20px;
        }
    }

    .subtitle {
        font-size: 22px !important;
    }

    //

    .nav-logo {
        width: 160px;
    }

    .nav-links {
        gap: 48px;

        a {
            font-size: 25px;
        }
    }

    .nav-btns {
        gap: 38px;
    }

    .default-btn {
        font-size: 22px;
        width: 210px;
    }

    .footer-img {
        width: 160px;
    }

    .footer-img-wrapper p {
        font-size: 18px;
    }

    .footer-links {
        .title {
            font-size: 26px;
        }

        a {
            font-size: 20px;
        }
    }

    .footer-socials {
        .social {
            width: 30px;
            height: 30px;
        }

        .youtube {
            width: 38px;
            height: 30px;
        }

        .facebook {
            width: 14px;
            height: 24px;
        }
    }

    footer .footer-bottom {
        p {
            font-size: 20px;
        }

        .terms a {
            font-size: 20px;
        }
    }
}

/* 2470 - 1328 */
@media (min-width: 2470px) {}

/*2560-1440*/
@media (min-width: 2560px) {

    //terms
    .header-banner p {
        font-size: 38px;
    }

    .body {

        p,
        a {
            font-size: 22px;
        }
    }

    .subtitle {
        font-size: 24px !important;
    }

    .text-wrapper {
        margin-bottom: 25px;
    }

    //

    .nav-logo {
        width: 180px;
    }

    .nav-links {
        gap: 52px;

        a {
            font-size: 28px;
        }
    }

    .nav-btns {
        gap: 40px;
    }

    .default-btn {
        font-size: 24px;
        width: 250px;
    }

    .footer-img {
        width: 180px;
    }

    .footer-img-wrapper p {
        font-size: 20px;
    }

    .footer-links {
        .title {
            font-size: 28px;
        }

        a {
            font-size: 22px;
        }
    }

    .footer-socials {
        .social {
            width: 35px;
            height: 35px;
        }

        .youtube {
            width: 43px;
            height: 35px;
        }

        .facebook {
            width: 19px;
            height: 29px;
        }
    }

    footer .footer-bottom {
        p {
            font-size: 22px;
        }

        .terms a {
            font-size: 22px;
        }
    }
}

/* 2880-1670 */
@media(min-width: 2880px) {}

/* 3000-1870 */
@media(min-width: 3000px) {

    //terms
    .header-banner p {
        font-size: 40px;
    }

    .body {

        p,
        a {
            font-size: 24px;
        }
    }

    .subtitle {
        font-size: 26px !important;
    }

    .text-wrapper {
        margin-bottom: 30px;
    }

    // 

    .nav-logo {
        width: 200px;
    }

    .nav-links {
        gap: 55px;

        a {
            font-size: 30px;
        }
    }

    .nav-btns {
        gap: 45px;
    }

    .default-btn {
        font-size: 26px;
        width: 300px;
    }

    .footer-img {
        width: 200px;
    }

    .footer-img-wrapper p {
        font-size: 22px;
    }

    .footer-links {
        .title {
            font-size: 30px;
        }

        a {
            font-size: 24px;
        }
    }

    .footer-socials {
        .social {
            width: 40px;
            height: 40px;
        }

        .youtube {
            width: 48px;
            height: 40px;
        }

        .facebook {
            width: 24px;
            height: 39px;
        }
    }

    footer .footer-bottom {
        p {
            font-size: 24px;
        }

        .terms a {
            font-size: 24px;
        }
    }
}

/*3200-1800*/
@media(min-width: 3200px) {

    //terms
    .header-banner p {
        font-size: 42px;
    }

    .body {

        p,
        a {
            font-size: 26px;
        }
    }

    .subtitle {
        font-size: 28px !important;
    }

    //
}

/*3360-1890 1695*/
@media(min-width:3360px) {

    //terms
    .header-banner p {
        font-size: 44px;
    }

    .body {

        p,
        a {
            font-size: 28px;
        }
    }

    .subtitle {
        font-size: 30px !important;
    }

    .text-wrapper {
        margin-bottom: 35px;
    }

    //
}

@media(max-width: 1800px) {
    .body {
        padding: 0 220px;
        margin-bottom: 160px;
    }
}

/* macbook pro 16 2021 */
/*1728x1085*/
@media(max-width: 1728px) {
    .header-banner {
        padding: 140px 0;
    }

    .body {
        padding: 0 180px;
    }
}

/*1680-1080*/
@media(max-width: 1680px) {}

/*1640-1080*/
@media(max-width: 1640px) {
    .header-banner {
        padding: 120px 0;

        p {
            font-size: 30px;
        }
    }

    .body {
        padding: 0 150px;
        margin-bottom: 140px;

        p,
        a {
            font-size: 16px;
        }
    }

    .subtitle {
        font-size: 18px !important;
    }
}

/*my big monitor 1600 - 757 */
@media (max-width: 1600px) {
    .body {
        width: 85%;
        padding: 0;
        margin: 0 auto;
        margin-bottom: 120px;
    }
}

/*my small monitor 1536-864*/
@media(max-width:1536px) {}

/* 1440-990 */
@media(max-width:1440px) {}

/*1366-768*/
@media (max-width:1366px) {

    footer {
        .footer-wrapper {
            width: 85%;
        }

        .footer-bottom {
            p {
                font-size: 16px;
            }

            .terms {
                gap: 80px;

                a {
                    font-size: 16px;
                }
            }
        }
    }
}

/* 1280-800 */
@media (max-width:1280px) {
    .header-banner {
        padding: 90px 0;

        p {
            font-size: 28px;
        }
    }

    .body {
        width: 90%;
        margin-bottom: 100px;
    }

    nav {
        width: 90%;
    }
}

@media (max-width:1200px) {
    .header-banner {
        padding: 70px 0;

        p {
            font-size: 24px;
        }
    }

    .body {

        p,
        a {
            font-size: 14px;
        }
    }

    .subtitle {
        font-size: 16px !important;
    }

    .nav-logo {
        width: 90px;
    }

    .nav-links {
        gap: 35px;

        a {
            font-size: 14px;
        }
    }

    .default-btn {
        width: 160px;
        font-size: 14px;
    }

    footer {
        .footer-top {
            margin-bottom: 50px;

            .footer-img-wrapper {
                .footer-img {
                    width: 90px;
                }

                p {
                    font-size: 12px;
                }
            }

            .footer-links {
                .title {
                    font-size: 18px;
                }

                a {
                    font-size: 14px;
                }
            }

            .footer-socials .youtube {
                width: 24px;
                height: 16px;
            }
        }

        .footer-bottom {
            p {
                font-size: 14px;
            }

            .terms a {
                font-size: 14px;
            }
        }
    }
}

/*1134x712*/
@media(max-width:1134px) {}

/*1114x705*/
@media(max-width:1114px) {}

/*1024-768*/
@media (max-width:1024px) {}

/* ipad pro 2/3 */
/* 981x1024 */
@media (max-width:981px) {
    .body {
        width: 95%;
        margin-bottom: 80px;
    }

    .header-banner {
        p {
            font-size: 22px;
        }

        padding: 65px 0;
        margin-bottom: 45px;
    }

    nav,
    footer .footer-wrapper {
        width: 95%;
    }

    .footer-socials .youtube {
        width: 24px;
        height: 16px;
    }
}

/* 962x601 */
@media(max-width: 962px) {
    .nav-links {
        gap: 25px;
    }

    .nav-btns {
        gap: 20px;
    }
}

/* 900x1600 */
@media(max-width: 900px) {
    .nav-links {
        gap: 20px;
    }

    .nav-btns {
        gap: 16px;
    }

}

/* 884 x 1104 */
@media(max-width: 884px) {}

/*834-1112*/
@media(max-width: 834px) {
    .nav-links {
        gap: 14px;
    }

}

/* 820x1080 */
@media(max-width: 820px) {}

/* 800x1280 */
@media(max-width: 800px) {}

/*778-304*/
@media(max-width: 778px) {}

/* 768x1024 */
@media(max-width: 768px) {

    footer {
        .footer-top {
            .footer-links .title {
                font-size: 16px;
            }

            .footer-socials {
                gap: 25px;
            }
        }

        .footer-bottom {
            p {
                font-size: 12px;
            }

            .terms {
                gap: 40px;

                a {
                    font-size: 12px;
                }
            }
        }
    }

    .login-menu-link-wrapper a {
        border: 1px solid #FF3A67;
        border-radius: 20px;
        padding: 4px 15px;
        color: #FF3A67;
    }

}

/*712-1138*/
@media(max-width:712px) {}

/* 694-768 */
@media(max-width:694px) {}

/* 678-1024 */
@media(max-width:678px) {
    footer {
        padding: 25px 0;

        .footer-top {
            flex-direction: column;
            margin-bottom: 50px;

            .footer-img-wrapper {
                .footer-img {
                    margin: 0 auto;
                }

                p {
                    font-size: 16px;
                    text-align: center;
                    margin-top: 20px;
                }
            }

            .footer-links {
                text-align: center;
                margin-top: 46px;

                .title {
                    font-size: 19px;
                    margin-bottom: 30px;
                }

                a {
                    font-size: 17px;
                }
            }

            .footer-socials {
                margin-top: 40px;
                justify-content: center;
                gap: 35px;

                .youtube {
                    width: 28px;
                    height: 20px;
                }
            }
        }

        .footer-bottom {
            flex-direction: column;

            p {
                font-size: 16px;
            }

            .terms {

                a {
                    font-size: 14px;
                }
            }

            .copyright {
                margin-bottom: 30px;
                width: 190px;
                text-align: center;
            }
        }
    }

}

/* 600x962 */
@media(max-width:600px) {}

/* 577-951 */
@media(max-width:577px) {}

/* 540-960 */
@media(max-width:540px) {}

/*480-800*/
@media (max-width:480px) {
    .header-banner p {
        font-size: 20px;
    }

    .body {
        margin-bottom: 50px;
    }

    nav,
    footer .footer-wrapper {
        width: 95%;
    }

}

/*438-1024*/
@media(max-width:438px) {}

/* ip14 pro max */
/* 430x932 */
@media(max-width:430px) {
    .header-banner {
        padding: 55px 0;
        margin-bottom: 30px;

        p {
            font-size: 18px;
        }
    }
}

/* ip13 pro max */
/* 428-926 */
@media (max-width:428px) {}

/*414-736 617   */
@media (max-width:414px) {

    footer .footer-bottom .terms {
        gap: 30px;
    }

}

/*390 x 844*/
@media(max-width:393px) {}

/*384-640*/
@media(max-width:384px) {}

/*375*/
@media(max-width:375px) {}

/*360x640*/
@media(max-width:360px) {
    .header-banner {
        padding: 45px 0;

        p {
            font-size: 16px;
        }
    }

    .body {

        p,
        a {
            font-size: 12px;
        }
    }

    .subtitle {
        font-size: 14px !important;
    }
}

/*320x568*/
@media(max-width:320px) {}
</style>
